webpackJsonp([49],{

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1067);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("0d5f3204", content, true, {});

/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.center-buttons{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/build/repo/src/pages/configuration/page-dealers-application.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,gBAAgB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CACzM","file":"page-dealers-application.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.center-buttons{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dealers-application"},[_c('action-sidebar',{attrs:{"title":"Aplicaciones","value":true,"width":700},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('v-flex',{attrs:{"xs9":"","text-xs-right":"","px-3":"","py-3":"","mt-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","label":"Proyectos","background-color":"white","hide-details":"","items":_vm.projectsAssigned,"name":"Proyectos","item-text":"name","item-value":"id"},on:{"change":function($event){return _vm.listApplicationsAssigned(1)}},model:{value:(_vm.projectId),callback:function ($$v) {_vm.projectId=$$v},expression:"projectId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('app-table',{staticClass:"mt-4 px-3",attrs:{"inputSearch":false,"filterColumns":false,"selectable":"","name":"application","rows":_vm.listApplications,"check-all":_vm.checkAll,"columns":_vm.columns,"last-page":_vm.lastPage,"current-page":_vm.currentPage,"selected-value":_vm.selectedValue},on:{"on-page":_vm.listApplicationsAssigned,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.repo)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.codeApp)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.project.data.name)+"\n\t\t\t\t\t\t\t\t")])]}}])})],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{attrs:{"xs9":"","mt-4":""}},[_c('v-select',{staticClass:"body-1 px-3",attrs:{"box":"","label":"Proyectos","background-color":"white","hide-details":"","items":_vm.projectsDeallocated,"name":"Proyectos","item-text":"name","item-value":"id"},on:{"change":function($event){return _vm.listApplicationsDeallocated(1)}},model:{value:(_vm.projectIdDeallocated),callback:function ($$v) {_vm.projectIdDeallocated=$$v},expression:"projectIdDeallocated"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('app-table',{staticClass:"px-3 mt-4",attrs:{"inputSearch":false,"filterColumns":false,"rows":_vm.listDeallocated,"columns":_vm.columns,"last-page":_vm.lastPageDeallocated,"current-page":_vm.currentPageDeallocated,"selected-value":_vm.selectedValueDeallocated,"check-all":_vm.checkAllDeallocated,"selectable":""},on:{"on-page":_vm.listApplicationsDeallocated,"row-is-selected":_vm.rowIsSelectedDeallocated,"on-selected-all":_vm.allSelectedDeallocated},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.repo)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.codeApp)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.project.data.name)+"\n\t\t\t\t\t\t\t")])]}}])})],1)],1)],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-4 pb-4 center-buttons"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action ml-2",attrs:{"color":"success","disabled":_vm.disabledAssigned(1)},on:{"click":_vm.assignedApplications}},[_vm._v("\n\t\t\t\tAsignar\n\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action ml-2",attrs:{"color":"success","disabled":_vm.disabledDeallocate(0)},on:{"click":_vm.deallocatedApplications}},[_vm._v("\n\t\t\t\tDeasignar\n\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_application_vue__ = __webpack_require__(845);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329fce10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_application_vue__ = __webpack_require__(1068);
function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_application_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329fce10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_application_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(164);




var deallocatedApplications = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var ids, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						ids = this.dataSelectedDeallocated.map(function (l) {
							return l.id;
						});
						body = {
							appsIds: ids
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/apps', { data: body });

					case 5:
						this.showNotification('Las aplciaciones fueron desasignadas correctamente.');
						this.listApplicationsDeallocated();
						this.closeModal();
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 10]]);
	}));

	return function deallocatedApplications() {
		return _ref.apply(this, arguments);
	};
}();

var assignedApplications = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var appsIds;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						appsIds = this.dataSelected.map(function (p) {
							return p.id;
						});
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('distributaries/' + this.id + '/apps', { appsIds: appsIds });

					case 4:
						this.showNotification('Las aplicaciones fueron asignadas correctamente');
						this.listApplicationsAssigned();
						this.closeModal();
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9]]);
	}));

	return function assignedApplications() {
		return _ref2.apply(this, arguments);
	};
}();

var listApplicationsAssigned = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.currentPage = page;
						this.params.page = this.currentPage;
						params = {
							projectId: this.projectId,
							isSelected: 0,
							page: this.params.page,
							perPage: 20
						};
						_context3.prev = 3;
						_context3.next = 6;
						return this.$http.get('distributaries/' + this.id + '/apps', { params: params });

					case 6:
						response = _context3.sent;

						this.listApplications = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context3.next = 14;
						break;

					case 11:
						_context3.prev = 11;
						_context3.t0 = _context3['catch'](3);

						if (_context3.t0.status === 500) {
							this.showError();
						}

					case 14:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[3, 11]]);
	}));

	return function listApplicationsAssigned() {
		return _ref3.apply(this, arguments);
	};
}();

var listApplicationsDeallocated = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var paramsDeallocated, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.currentPageDeallocated = page;
						this.params.page = this.currentPageDeallocated;
						paramsDeallocated = {
							projectId: this.projectIdDeallocated,
							isSelected: 1,
							page: this.params.page,
							perPage: 20
						};
						_context4.prev = 3;
						_context4.next = 6;
						return this.$http.get('distributaries/' + this.id + '/apps', { params: paramsDeallocated });

					case 6:
						response = _context4.sent;

						this.listDeallocated = response.data.data;
						this.lastPageDeallocated = Number(response.headers['x-last-page']);
						_context4.next = 14;
						break;

					case 11:
						_context4.prev = 11;
						_context4.t0 = _context4['catch'](3);

						if (_context4.t0.status === 500) {
							this.showError();
						}

					case 14:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[3, 11]]);
	}));

	return function listApplicationsDeallocated() {
		return _ref4.apply(this, arguments);
	};
}();

var listProjectAssigned = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						params = {
							isSelected: 1,
							page: 1,
							perPage: 20
						};
						_context5.prev = 1;
						_context5.next = 4;
						return this.$http.get('distributaries/' + this.id + '/projects', { params: params });

					case 4:
						response = _context5.sent;

						this.projectsAssigned = response.data.data;
						_context5.next = 11;
						break;

					case 8:
						_context5.prev = 8;
						_context5.t0 = _context5['catch'](1);

						if (_context5.t0.status === 500) {
							this.showError();
						}

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[1, 8]]);
	}));

	return function listProjectAssigned() {
		return _ref5.apply(this, arguments);
	};
}();

var listProjectDeallocated = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						params = {
							isSelected: 1,
							page: 1
						};
						_context6.prev = 1;
						_context6.next = 4;
						return this.$http.get('distributaries/' + this.id + '/projects', { params: params });

					case 4:
						response = _context6.sent;

						this.projectsDeallocated = response.data.data;
						_context6.next = 11;
						break;

					case 8:
						_context6.prev = 8;
						_context6.t0 = _context6['catch'](1);

						if (_context6.t0.status === 500) {
							this.showError();
						}

					case 11:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[1, 8]]);
	}));

	return function listProjectDeallocated() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.listProjectAssigned();
	this.listProjectDeallocated();
	this.listApplicationsAssigned();
	this.listApplicationsDeallocated();
}

function rowIsSelected(row) {
	this.listApplications = this.selectIsRow(this.listApplications, this.selectedValue, row);
	this.checkAll = this.every(this.listApplications, this.selectedValue);
	this.dataSelected = this.listApplications.filter(function (r) {
		return r.selectedAssigned;
	});
}

function rowIsSelectedDeallocated(row) {
	this.listDeallocated = this.selectIsRow(this.listDeallocated, this.selectedValueDeallocated, row);
	this.checkAllDeallocated = this.every(this.listDeallocated, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.listDeallocated.filter(function (r) {
		return r.flag;
	});
}

function allSelectedDeallocated(checked) {
	var _this = this;

	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.listDeallocated = this.listDeallocated.map(function (element) {
		var newDeallocated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newDeallocated.isSelected = checked;
		if (checked) {
			_this.dataSelectedDeallocated.push(element);
		}
		return newDeallocated;
	});
	this.rowsDealllistDeallocatedocated = this.selectIsRow(this.listDeallocated, this.selectedValueDeallocated, false, checked);
}

function allSelected(checked) {
	var _this2 = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.listApplications = this.listApplications.map(function (element) {
		var newApplications = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newApplications.isSelected = checked;
		if (checked) {
			_this2.dataSelected.push(element);
		}
		return newApplications;
	});
	this.listApplications = this.selectIsRow(this.listApplications, this.selectedValue, false, checked);
}

function disabledAssigned(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

function disabledDeallocate(value) {
	return this.tabsModel === value || this.dataSelectedDeallocated.length < 1;
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function data() {
	return {
		dataSelected: [],
		dataSelectedDeallocated: [],
		checkAllDeallocated: false,
		checkAll: false,
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Repositorio', value: 'repository', checked: true, visible: true }, { id: 3, name: 'Cod. App', value: 'codeApp', checked: true, visible: true }, { id: 4, name: 'Proyecto', value: 'project', checked: true, visible: true }],
		currentPageDeallocated: 1,
		currentPage: 1,
		listDeallocated: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		listApplications: [],
		projectsAssigned: [],
		projectsDeallocated: [],
		projectIdDeallocated: '',
		projectId: '',
		selectedValue: 'selectedAssigned',
		selectedValueDeallocated: 'flag',
		rowsDeallocated: [],
		tabsModel: null,
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-dealers-application',
	created: created,
	data: data,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"]
	},
	methods: {
		allSelected: allSelected,
		allSelectedDeallocated: allSelectedDeallocated,
		assignedApplications: assignedApplications,
		closeModal: closeModal,
		deallocatedApplications: deallocatedApplications,
		disabledAssigned: disabledAssigned,
		disabledDeallocate: disabledDeallocate,
		listApplicationsAssigned: listApplicationsAssigned,
		listApplicationsDeallocated: listApplicationsDeallocated,
		listProjectAssigned: listProjectAssigned,
		listProjectDeallocated: listProjectDeallocated,
		rowIsSelected: rowIsSelected,
		rowIsSelectedDeallocated: rowIsSelectedDeallocated
	},
	props: {
		id: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/49.20ebd1434447ed68065f.js